import React from 'react';
import { connect } from 'react-redux';
import { mediaPickerActions } from '../../store';
import MediaPickerTabs from '../../common/MediaPickerTabs';
import MediaPickersConstants from '../../MediaPickersConstants';

const BackgroundPickerTabs = (props) => {
    const { backgroundPickerSelectedTab, setProperty, backgroundAssetsCount, loadUserBackgroundAssets, loadInitialBackgroundCatalogVideos, loadDefaultBackgroundStockImages, accountDetails } = props;

    const onSelectedTabChange = (e, value) => {
        if (backgroundPickerSelectedTab === value || value === null)
            return;

        if (value === MediaPickersConstants.MEDIA_PICKER_TABS.MY_ASSETS && !backgroundAssetsCount) 
            loadUserBackgroundAssets(1, MediaPickersConstants.BACKGROUND_ASSETS_PER_PAGE);
        
        if (value === MediaPickersConstants.MEDIA_PICKER_TABS.VIDEOS)
            loadInitialBackgroundCatalogVideos(); 

        // The dialog opens on My Assets, so the stock gallery is only fetched once it is asked for.
        if (value === MediaPickersConstants.MEDIA_PICKER_TABS.IMAGES)
            loadDefaultBackgroundStockImages();

        setProperty('backgroundPickerSelectedTab', value);
    };

    return (
        <MediaPickerTabs
            selectedTab={backgroundPickerSelectedTab}
            onTabChange={onSelectedTabChange}
            enabledTabs={MediaPickersConstants.BACKGROUND_PICKER_ENABLED_TABS}
            userAuthenticated={Boolean(accountDetails.email)}
        />
    );
};

const mapStateToProps = (state) => {
    const { backgroundPickerSelectedTab, backgroundAssetsCount, backgroundAssets } = state.mediaPicker;
    const { accountDetails } = state.app;

    return { 
        backgroundPickerSelectedTab,
        backgroundAssetsCount,
        backgroundAssets, 
        accountDetails
    };
}

const mapDispatchToProps = (dispatch) => {
    const setProperty = (key, value) => dispatch(mediaPickerActions.setProperty(key, value));
    const loadUserBackgroundAssets = (pageNumber, itemsPerPage) => dispatch(mediaPickerActions.loadUserBackgroundAssets(pageNumber, itemsPerPage));
    const loadInitialBackgroundCatalogVideos = () => dispatch(mediaPickerActions.loadInitialBackgroundCatalogVideos());
    const loadDefaultBackgroundStockImages = () => dispatch(mediaPickerActions.loadDefaultBackgroundStockImages());

    return { 
        setProperty, 
        loadUserBackgroundAssets,
        loadInitialBackgroundCatalogVideos,
        loadDefaultBackgroundStockImages
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(BackgroundPickerTabs);